exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".chat_input_com[data-v-07b28c78]{width:100%;height:100%;-webkit-box-sizing:border-box;box-sizing:border-box;overflow-x:hidden;overflow-y:auto}.chat_input_com[data-v-07b28c78]::-webkit-scrollbar{width:7px;height:7px}.chat_input_com .input_box[data-v-07b28c78]{padding:8px 10px;cursor:text;outline:none;line-height:16px}.chat_input_com .input_box .emoji[data-v-07b28c78]{width:24px;height:24px;vertical-align:middle;display:inline-block}\n", ""]);

// exports
